import { render, staticRenderFns } from "./TxRowSimple.vue?vue&type=template&id=5e3495b0"
import script from "./TxRowSimple.vue?vue&type=script&lang=js"
export * from "./TxRowSimple.vue?vue&type=script&lang=js"
import style0 from "./TxRowSimple.vue?vue&type=style&index=0&id=5e3495b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports